/**
 * Error Response Utility
 * Creates standardized error responses for API failures
 *
 * Copied from: 3in1cms/bajajfinserv-web/ui.solid/src/lib/util/errorResponse.ts
 */

export function createErrorResponse<T extends object>(
  errorFields: Partial<T>,
  description = "Error occurred",
  statusCode = "7002",
  status = "E",
  message = "Something went wrong"
): T & {
  description: string;
  statusCode: string;
  status: string;
  message: string;
} {
  return {
    ...errorFields,
    description,
    statusCode,
    status,
    message,
  } as T & {
    description: string;
    statusCode: string;
    status: string;
    message: string;
  };
}
